// extracted by mini-css-extract-plugin
export default {"NoAvatar":"styles_NoAvatar__FPEC6","hovered":"styles_hovered__QQBUm","bounce":"styles_bounce__Xllff","notHovered":"styles_notHovered__n2qmc","bounceOut":"styles_bounceOut__A-7Gn"};